import React from 'react'
import MaterialSymbol from '../material-symbol'

const Trophy = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="trophy" {...props} />
))

Trophy.displayName = 'Trophy'

export default Trophy
